import React, { Component } from 'react'
import * as nav from '../../../lib/nav';

class Callback extends Component {

  UNSAFE_componentWillMount(){
    const { search, pathname } = this.props.location;
    this.props.history.push({
        pathname: nav.AUTH,
        search,
        redirectUrl: `http://localhost:3000${pathname}`
    })
  }

  render() {
    return (
      <div >
      </div>
    )
  }
}

export default Callback